import { render } from "./ProductEditorModal.vue?vue&type=template&id=4d9f2df1&scoped=true"
import script from "./ProductEditorModal.vue?vue&type=script&lang=js"
export * from "./ProductEditorModal.vue?vue&type=script&lang=js"

import "./ProductEditorModal.vue?vue&type=style&index=0&id=4d9f2df1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9f2df1"]])

export default __exports__